export const fontPrefix = '--fonts-';

export const fonts: Record<string, string> = {
  primaryFontFamily: 'Open Sans, sans-serif',
};

export const fontsToCssVariables = (overwrittenFonts?: Record<string, string>): string => {
  const mergedColors: Record<string, string> = { ...fonts };

  if (overwrittenFonts) {
    Object.entries(overwrittenFonts).forEach(([key, value]) => {
      if (value !== '' && value !== undefined) mergedColors[key] = value;
    });
  }

  const cssVariables = Object.entries(mergedColors)
    .map(([key, value]) => `${fontPrefix}${key}: ${value};`)
    .join(' ');

  return `* { ${cssVariables} }`;
};
